import { Card, CardBody, CardHeader, Divider } from "@nextui-org/react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import { useMemo, useState, useCallback } from "react";
import useSWR from "swr";
import { getFetcher } from "../../../../services/api";
import ClientDataGrid from "../../../../components/elements/ClientDataGrid";

export default function IndexPage() {
  const [searchQuery, setSearchQuery] = useState("");

  // 1. Data dipanggil secara keseluruhan saat pertama kali halaman di-load
  const { data, isLoading } = useSWR(
    `/api/rekom/permohonan/search-pengangkut-b3/all`,
    getFetcher
  );

  //console.log('Response API: ', data);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
  }, []);

  // Proses pencarian dan penyajian baris data untuk ClientDataGrid
  const rows = useMemo(() => {
    const rawData = Array.isArray(data) ? data : data?.data || [];
    
    // Rule 1 & 2: Jangan tampilkan data (tahan) jika teks kurang dari 3 karakter
    if (searchQuery.length < 3) {
      return [];
    }

    // Mengecek apakah inputan HANYA berisi angka, spasi, atau strip (mengindikasikan pencarian CAS Number)
    //const isNumericSearch = /^[\d\s\-]+$/.test(searchQuery);
    const isNumericSearch = /^[\d\s-]+$/.test(searchQuery);

    const filteredData = rawData.filter((item) => {
      if (isNumericSearch) {
        // Rule 3 & 4: Pencarian berdasarkan casNumber.
        // Hapus tanda strip (atau karakter non-alphanumeric) baik pada input maupun di database untuk mencocokkan.
        const searchClean = searchQuery.replace(/[^0-9a-zA-Z]/g, '').toLowerCase();
        const casClean = item.casNumber ? item.casNumber.replace(/[^0-9a-zA-Z]/g, '').toLowerCase() : '';
        
        return casClean.includes(searchClean);
      } else {
        // Rule 5: Jika mengandung huruf, pencarian berdasarkan kabkot (Kota/Kabupaten)
        const kabkot = item.kabkot ? item.kabkot.toLowerCase() : '';
        return kabkot.includes(searchQuery.toLowerCase());
      }
    });
    
    // Memberikan properti 'id' karena ClientDataGrid (MUI) mewajibkannya
    return filteredData.map((item, index) => ({
      ...item,
      id: index, 
    }));
  }, [data, searchQuery]);

  // Menyesuaikan Header/Kolom Tabel dengan output SQL
  const columns = useMemo(
    () => [
      // Perhatikan field diubah menjadi 'perusahaan' menyesuaikan hasil SELECT sql dari backend sebelumnya
      { field: "perusahaan", headerName: "Nama Perusahaan", flex: 1, minWidth: 250 },
      { field: "namaPemohon", headerName: "PIC Perusahaan", flex: 1, minWidth: 180 },
      { field: "telpPIC", headerName: "Telepon/HP", width: 120 },
      { field: "emailKantor", headerName: "Email", flex: 1, minWidth: 220 },
      { field: "casNumber", headerName: "CAS Number", flex: 1, minWidth: 110 },
      { field: "namaBahanKimia", headerName: "Nama Bahan", flex: 1, minWidth: 150 },
      { field: "kabkot", headerName: "Kota/Kabupaten", flex: 1, minWidth: 230 },
    ],
    []
  );

  return (
    <RootAdmin>
      <Card className="w-full mt-3" radius="sm">
        <CardHeader>
          <p className="text-md">Pencarian Perusahaan Pengangkut B3</p>
        </CardHeader>
        <Divider />
        <CardBody className="w-full h-[550px] p-5">
          <div className="mb-5" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            {/* Form Input Pencarian (tanpa tombol Submit agar otomatis/real-time) */}
            <SearchField 
              value={searchQuery} 
              onChange={handleSearchChange} 
              placeholder="CAS Number atau Kota/Kabupaten ..." 
            />
          </div>
          
          <ClientDataGrid
            rows={rows}
            rowCount={rows.length}
            isLoading={isLoading}
            columns={columns}
            autoResize={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "perusahaan", sort: "asc" }],
              },
            }}
          />
        </CardBody>
      </Card>
    </RootAdmin>
  );
}

function SearchField({ value, onChange, placeholder }) {
  return (  
    <div className="flex w-full items-center">
      {/* Menggunakan custom width agar responsif dan nyaman dilihat */}
      <div className="w-full sm:w-[330px]">
        <input
          type="text"
          id="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full px-3 py-2 border border-line-strong rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        />
      </div>
    </div>
  );
}
